import { setStpRates } from '@va/aaas/shared/actions';
import { AaasClient } from '@va/aaas/shared/api-client';
import { StpCounterResponse } from '@va/aaas/shared/types';
import { getInstanceId } from '@va/dashboard/selectors/app';
import { call, put, select } from 'redux-saga/effects';

export function* fetchStpRatesSaga(): Generator {
  const websiteId = (yield select(getInstanceId)) as string;
  try {
    const data = (yield call(AaasClient.getStpRates, websiteId)) as StpCounterResponse;
    yield put(setStpRates(data));
  } catch (error) {
    console.error(error);
  }
}
